import { Component, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { SwalService } from 'src/app/core/services/swal.service';
import { EventEmitterService } from 'src/app/core/services/event-emitter.service';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import * as FileSaver from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalVariableService } from 'src/app/core/services/global-variable.service';
import { DatePipe } from '@angular/common'
import {AppConfigService} from "../../../../../../core/services/config.service";

@Component({
  selector: 'app-analyse-eia',
  templateUrl: './analyse-eia.component.html',
  styleUrls: ['./analyse-eia.component.css'],
})
export class AnalyseEiaComponent implements OnInit {

  API_URL: any;
  direction: any;
  selectedDirection: any;
  settingsDirection = {};
  listDirection: any = [];
  matricule: any;
  loaderText: any;
  id_direction: any;
  code_direction: any;
  response: any;
  filename;
  constructor(
    private _service: AppService,
    private configService: AppConfigService,
    private _loader: LoadingBarService,
    private _swal: SwalService,
    private eventEmitter: EventEmitterService,
    private _router: Router,
    private title: Title,
    private storage: LocalStorageService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private variable: GlobalVariableService,
    public datepipe: DatePipe,
  ) {
    this.API_URL = configService.get('HOST_API_ONLINE');
  }

  ngOnInit() {
    this.getAllDirection();
    this.title.setTitle('Reporting EIA | HR Performance');
    this.settingsDirection = {
      singleSelection: true,
      text: 'Selectionner la direction',
      classes: 'myclass custom-class',
      labelKey: 'code',
      enableSearchFilter: true,
      searchBy: ['code'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucune direction disponible'
    };
  }

  getAllDirection() {
    this._loader.start();
    this._service.getData('capital-humain/structures/direction')
      .subscribe(
        res => {
          if (res.error === false) {
            this._loader.stop();
            this.listDirection = res.data;
          } else {
            this._loader.stop();
            this._swal.error(res.message);
          }
        }, err => {
          this._loader.stop();
          this.toastrService.error(err.error.message);
        }
      );
  }

  // Get all direction
  onSelectDirection(item) {
    this.id_direction = item.id;
    this.code_direction = item.code;
  }

  onDeSelectItem() {
    this.id_direction = '';
    this.code_direction = '';
  }

  analyseRequete(idsheet) {
    const header = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      Authorization: 'Bearer ' + this.variable.getAccessToken(),
    }

    const requestOptions = {
      headers: new Headers(header),
    };
    this._loader.start();
    let today = new Date();
    let date = this.datepipe.transform(today, 'yyyy-MM-dd')
    this.filename = "Analyse_Req" + idsheet + "_" + this.code_direction + "_" + date;
    // if (res) {
    //   this._loader.stop();
    //   res => res.blob()
    // }
    return fetch(this.API_URL + `reporting/${this.storage.retrieve('idCampagneEiaSelected')}/${this.code_direction}/${idsheet}/analyse-eia`, requestOptions)
      .then(
        res => res.blob()
      )
      .then(blob => {
        FileSaver.saveAs(blob, this.filename);
        this._loader.stop();
      })
      .catch(err => {
        this._loader.stop();
        swal.fire({
          title: 'HR PERF',
          text: JSON.stringify(err),
          type: 'error',
          confirmButtonColor: '#FD7E14',
          confirmButtonText: 'Ok'
        });
      });
  }

  // analyseRequete(idsheet) {
  //   this._loader.start();
  //   this._service.getData(`reporting/${this.storage.retrieve('idCampagneEiaSelected')}/${this.code_direction}/${idsheet}/analyse-eia`)
  //     .subscribe(
  //       res => {
  //         if (res.error === false) {
  //           this._loader.stop();
  //           this.toastrService.success(res.message);
  //         } else {
  //           this._loader.stop();
  //           swal.fire({
  //             title: 'HR PERF',
  //             text: res.message,
  //             type: 'error',
  //             confirmButtonColor: '#FD7E14',
  //             confirmButtonText: 'Ok'
  //           });
  //         }
  //       }, err => {
  //         this._loader.stop();
  //         swal.fire({
  //           title: 'HR PERF',
  //           text: JSON.stringify(err),
  //           type: 'error',
  //           confirmButtonColor: '#FD7E14',
  //           confirmButtonText: 'Ok'
  //         });
  //       }
  //     );
  // }
}
